import React, { useState } from "react";

import image from "../../assests/about_image.webp";
import { Button, Form, Input, notification } from "antd";
import { POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import Header from "../componets/header/header";
import Footer from "../componets/footer/footer";

function Blog3() {
    const [isLoading, setIsLoading] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                visitorsId: values.visitorsId,
                type: "visitor",
                visitors_name: values.visitors_name,
                date: values.date || new Date().toISOString(),
                visitors_email: values.visitors_email,
                visitors_purpose: "from website",
                employee_id: 1,
                visitors_phone: values.visitors_phone,
                description: values.description,
                altPhone: values.altPhone,
            };

            setIsLoading(true);
            const api = API.CREATE_VISITORS;
            const postRequest: any = await POST(api, obj);
            if (postRequest.status) {
                notification.success({ message: "visitors created successfully!" });
                setIsLoading(false);
                setIsModalOpen(false);
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <Header />
            <div>
                <div style={{ position: "relative", textAlign: "center", color: "white" }}>
                    <img
                        src={image}
                        alt="Digital Marketing"
                        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
                    />

                    <h1 style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "50px",
                        fontWeight: "900",
                        margin: 0,
                        color: "rgb(255, 255, 255)"
                    }}>
                        The Digital Marketing for Modern Businesses
                    </h1>
                </div>

                <div style={{ padding: "20px" }} >
                    <p>
                        Welcome to the digital frontier, where a captivating online presence
                        is the key to business success! Yet, the ever-shifting landscape of
                        digital marketing can be daunting. Fear not, intrepid entrepreneur,
                        for <a>BEST DIGITAL MARKETING IN KOCHI</a> is here to guide you.
                        This serves as your comprehensive roadmap to navigating the exciting
                        world of digital marketing.
                    </p>

                    <div>
                        <h2 style={{ fontSize: "30px", fontWeight: "900" }}>
                            Your One-Stop Shop for Digital Domination
                        </h2>
                        <p>
                            Consider this blog your personal arsenal, stocked with the latest
                            tools and tactics to conquer the digital realm. We’ll equip you with
                            actionable strategies, industry insights, and expert advice to
                            propel your business forward:
                        </p>
                        <p>
                            Traffic & Leads Galore: Amplify website traffic and watch your leads
                            surge with our proven techniques. Brand Awareness Blitz: Become a
                            household name (BEST DIGITAL MARKETING AGENCY IN KOCHI) through
                            creative strategies to boost brand awareness and
                            engagement.Conversion Champions: Transform those valuable leads into
                            loyal customers with our conversion optimization tactics. Maximize
                            Your Marketing Muscle: Stretch your marketing budget further and see
                            a skyrocketing ROI with our data-driven approach. A smorgasbord of
                            Digital Delights
                        </p>
                        <p>
                            Whether you’re a seasoned marketing maestro or a fledgling
                            entrepreneur, we’ve got something to whet your digital appetite.
                            Dive into a cornucopia of topics, including:
                        </p>
                        <p>
                            SEO Savvy: Unravel the mysteries of search engine optimization and
                            climb the ranks of Google like a pro.PPC Powerhouse: Master the art
                            of pay-per-click advertising and target your ideal audience with
                            laser precision.Social Media Mastery: Become a social media
                            butterfly and cultivate a thriving online community around your
                            brand.Content Creation Captivation: Craft compelling content that
                            informs, entertains, and converts like a charm. Email Allure:
                            Harness the power of email marketing to nurture leads and build
                            lasting customer relationships.Analytics Alchemy: Transform data
                            into actionable insights and optimize your marketing campaigns for
                            peak performance.And the Adventure Continues!: Our knowledge vault
                            overflows with even more digital marketing gems waiting to be
                            unearthed.
                        </p>
                        <h2 style={{ fontSize: "30px", fontWeight: "900" }}>
                            Democratizing Digital Marketing
                        </h2>
                        <p>
                            At BEST DIGITAL MARKETING AGENCY IN KOCHI, we believe that powerful
                            digital marketing shouldn’t be a privilege reserved for a select
                            few. That’s why we craft content that’s
                        </p>
                        <p>
                            Information Packed: We deliver valuable insights and practical
                            strategies you can leverage in your next campaign.Actionable Edge:
                            Our content is clear, concise, and easy to implement, empowering you
                            to take charge of your digital marketing destiny.Engaging Narrative:
                            We weave information into a captivating tapestry that keeps you
                            glued to the screen DIGITAL MARKETING AGENCY.Embrace Growth,
                            Together
                        </p>
                        <p>
                            Don’t settle for stagnation in the ever-evolving digital landscape.
                            Unlock your business’s true potential with the power of our digital
                            marketing expertise. Subscribe now and join our vibrant community of
                            growth-hungry marketers!
                        </p>
                        <p>
                            Become a digital marketing guru: Subscribe to our blog for a steady
                            stream of cutting-edge marketing tips and tricks.Craft a customized
                            marketing strategy: Contact us today for a free consultation and
                            let’s tailor a digital marketing plan to perfectly suit your unique
                            business needs.Remember, with the right digital marketing compass,
                            your business can navigate the ever-changing online terrain and
                            achieve remarkable success. Let’s embark on this exciting journey
                            together!
                        </p>
                    </div>
                </div>
                <div>
                    <h2
                        style={{

                            fontSize: "30px",
                            fontWeight: "900",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Leave a Reply
                    </h2>
                    <p
                        style={{


                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Your email address will not be published. Required fields are marked
                        *
                    </p>
                    <Form
                        form={form}
                        name="contact_form"
                        onFinish={submitHandler}
                        layout="vertical"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                        <Form.Item
                            name="visitors_name"
                            rules={[{ required: true, message: "Please input your name!" }]}
                        >
                            <Input placeholder="Enter your name" />
                        </Form.Item>
                        <Form.Item
                            name="visitors_email"
                            rules={[
                                {
                                    required: true,
                                    type: "email",
                                    message: "Please input a valid email!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter your email" />
                        </Form.Item>
                        <Form.Item
                            name="visitors_phone"
                            rules={[
                                { required: true, message: "Please input your phoone number" },
                            ]}
                        >
                            <Input placeholder="Enter phone number" />
                        </Form.Item>
                        <Form.Item
                            name="description"
                            rules={[
                                { required: true, message: "Please input your message!" },
                            ]}
                        >
                            <Input.TextArea placeholder="Enter your message" rows={4} />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" block>
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Blog3;
